/* istanbul ignore file */
// libs
import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { sidebarMenuItemSx, sidebarSubitemsSx } from './sidebarMenuSx';

export interface SidebarMenuItemProps {
  linkUrl: string;
  name: string;
  icon?: string | React.ReactElement;
  exact?: boolean;
  isVisible?: boolean;
  children?: React.ReactElement | React.ReactElement[];
  staticItem?: boolean;
}

const SidebarMenuItem = ({
  linkUrl,
  icon,
  name,
  isVisible = true,
  exact = false,
  children,
  staticItem = false,
}: SidebarMenuItemProps) =>
  isVisible ? (
    <Fragment key={linkUrl}>
      <Typography
        component={NavLink}
        variant="inherit"
        to={linkUrl}
        className={`tabs-btn${staticItem ? ' static' : ''}`}
        end={exact}
        sx={sidebarMenuItemSx}
      >
        {icon && (typeof icon === 'string' ? <i className={`fa fa-${icon}`} aria-hidden /> : icon)}
        <Typography component="span" variant="inherit">
          {name}
        </Typography>
      </Typography>

      {children ? (
        <Box className="left-menu-subitems" sx={sidebarSubitemsSx}>
          {children}
        </Box>
      ) : null}
    </Fragment>
  ) : null;

export default SidebarMenuItem;
